import { Cart } from '~/src/common/typings/cart';
import { getCartQuantity } from '~/src/common/utils/cart/cart';
import { RecipeIngredientProductArticle } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

export const isMissingQuantity = ({
  article,
  cart,
}: {
  article: RecipeIngredientProductArticle;
  cart?: Cart;
}) => {
  const remainingQuantity = article.availableQuantity - getCartQuantity(cart, article);

  return article.availableQuantity > 0 && article.quantity > remainingQuantity;
};
